import MusakanPic from '../images/musakan.jpg';
import BurgerPic from '../images/burger.jpeg';

// src/data/recipes.js
export const recipeData = [
  {
    id: 1,
    title: "Musakhan",
    image: MusakanPic,
    description: "A simple, classic roast chicken with crispy skin and juicy meat. It's all about the high heat and butter.",
    servings: 4,
    prepTime: 30,
    cookTime: 90,
    ingredients: [
      "1 whole chicken cut into 4 pieces",
      "1 whole lemon",
      "salt and pepper",
      "1kg Onions",
      "150ml olive oil",
      "150 grams or sumac",
      "1 teaspoon temato paste",
      "1 teaspoon Onion poweder",
      "1 teaspoon garlic poweder",
      "100 ml of water",
      "2 taboon bread",
      "Nutes for garnish (pine nuts or almonds)"
    ],
    instructions: [
      "Chicken marinade: cut the lemon into four pieces place the lemon juice and lemon pieces on top of the chicken. marinade for 1 hour.",
      "Put the chicken into a baking tray use the marinade and add 1 teaspoon of tomatoe paste ,salt, pepper, onion powder, garlic poweder. and cover the tray will aluminume foil then cook for 45 minutes. (Cook on high heat 200C)",
      "Prepare the onions: cut the onions into cubes place into a pot add salt and cover for half anhour and ster every now and then, until the onions are lightly golden color add olive oil along witht the sumac and cook for another 5 min.",
      "Take the chicken out of the oven after 45 min add the chicken juices to the onions in the same baking trey place the taboon bread then place the chicken on top of the bread and add the onions then bake for another 10 min uncovered until the chicken is golden.",
    ]
  }, // <-- ADD THIS CLOSING BRACE AND COMMA
  {
    id: 2,
    title: "SOS Dish ( breakfast- Lunch or Dinner) ",
    image: BurgerPic,
    description: "A simple, classic roast chicken with crispy skin and juicy meat. It's all about the high heat and butter.",
    servings: 4,
    prepTime: 30,
    cookTime: 90,
    ingredients: [
      "400 gr. Ground beef",
      "1 medium-sized onion",
      "1 Tablespoon cooking oil",
      "1 Tablespoon butter",
      "1 Tablespoon of flour",
      "400 Cl. Milk",
      "Pinch of salt and pepper",
      "Pinch of nutmeg",
      "4 burger buns",
      "4 eggs",
      "2 taboon bread",
      "4 slices of cheddar cheese"
    ],
    instructions: [
      "Cooking method: Fry the onion with oil and butter until soft and the meat and cook for 10 minutes.",
      "Add the milk gradually until you have a thick minced meat with white sauce.",
      "Add salt pepper and nutmeg. Open the buns Toast till golden colour",
      "Fry the eggs sunny side up.",
      "building the sandwich",
      "Burger buns - minced meat white sauce - fried egg - cheddar cheese"
    ]
  } // <-- This closing brace is correct
];